export const SYSTEM_ALT_LOG_CONTACTS_OPEN_MODAL = "SYSTEM_ALT_LOG_CONTACTS_OPEN_MODAL";
export const SYSTEM_ALT_LOG_CONTACTS_REQUEST = "SYSTEM_ALT_LOG_CONTACTS_REQUEST";
export const SYSTEM_ALT_LOG_CONTACTS_RESULT = "SYSTEM_ALT_LOG_CONTACTS_RESULT";